import React from "react"; 
import PropTypes from "prop-types";
import DOMPurify from "dompurify";

export default function SafeHTML({ html }) {
  const cleanHTML = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });

  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

SafeHTML.propTypes = {
  html: PropTypes.string.isRequired,
};
